// src/pages/Plan/PlanQuestionnairePage.jsx - UPDATED WITH ELIGIBILITY CHECK
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { planService } from '../../services/planService';
import PlanQuestionnaire from '../../components/Plan/PlanQuestionnaire';
import PlanCreation from '../../components/Plan/PlanCreation';
import './PlanQuestionnairePage.css';

const PlanQuestionnairePage = () => {
  const navigate = useNavigate();
  const [currentQuestionnaire, setCurrentQuestionnaire] = useState(null);
  const [showPlanCreation, setShowPlanCreation] = useState(false);
  const [eligibilityChecked, setEligibilityChecked] = useState(false);
  const [canCreatePlan, setCanCreatePlan] = useState(true);
  const [eligibilityError, setEligibilityError] = useState(null);
  const [existingPlan, setExistingPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ NEW: Check eligibility on component mount
  useEffect(() => {
    checkEligibility();
  }, []);

  const checkEligibility = async () => {
    try {
      setLoading(true);
      const result = await planService.checkPlanEligibility();
      
      setCanCreatePlan(result.can_create);
      
      if (!result.can_create) {
        setEligibilityError(result.reason);
        setExistingPlan(result.existing_plan);
      }
      
      setEligibilityChecked(true);
    } catch (err) {
      console.error('Error checking eligibility:', err);
      setEligibilityError('Failed to check plan eligibility. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleQuestionnaireComplete = (questionnaire) => {
    setCurrentQuestionnaire(questionnaire);
    setShowPlanCreation(true);
  };

  const handlePlanCreationSuccess = (plan) => {
    alert(`Plan created successfully! Your plan "${plan.plan_name}" is now active.`);
    navigate('/dashboard');
  };

  const handleClosePlanCreation = () => {
    setShowPlanCreation(false);
    setCurrentQuestionnaire(null);
  };

  const handleBack = () => {
    navigate('/plan');
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleViewExistingPlan = () => {
    if (existingPlan && existingPlan.id) {
      navigate(`/plan/${existingPlan.id}`);
    } else {
      navigate('/dashboard');
    }
  };

  // Show loading state
  if (loading) {
    return (
      <div className="plan-questionnaire-page">
        <div className="eligibility-check-loading">
          <div className="spinner"></div>
          <p>Checking your plan eligibility...</p>
        </div>
      </div>
    );
  }

  // ✅ NEW: Show eligibility error if user cannot create plan
  if (!canCreatePlan) {
    return (
      <div className="plan-questionnaire-page">
        <button onClick={handleBack} className="back-button">
          ← Back to Plan Overview
        </button>
        
        <div className="eligibility-error-container">
          <div className="eligibility-error-card">
            <div className="error-icon">🚫</div>
            <h2>Cannot Create New Plan</h2>
            <p className="error-message">{eligibilityError}</p>
            
            {existingPlan && (
              <div className="existing-plan-info">
                <h3>Your Current Plan</h3>
                <div className="plan-details">
                  <div className="plan-detail-item">
                    <span className="label">Plan Name:</span>
                    <span className="value">{existingPlan.name}</span>
                  </div>
                  <div className="plan-detail-item">
                    <span className="label">Status:</span>
                    <span className={`value status-${existingPlan.status.toLowerCase()}`}>
                      {existingPlan.status}
                    </span>
                  </div>
                  <div className="plan-detail-item">
                    <span className="label">Balance:</span>
                    <span className="value">₦{parseFloat(existingPlan.balance).toLocaleString()}</span>
                  </div>
                </div>
              </div>
            )}
            
            <div className="action-buttons">
              <button onClick={handleViewExistingPlan} className="primary-button">
                View Current Plan
              </button>
              <button onClick={handleGoToDashboard} className="secondary-button">
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Show questionnaire or plan creation if eligible
  return (
    <div className="plan-questionnaire-page">
      <button onClick={handleBack} className="back-button">
        ← Back to Plan Overview
      </button>

      {!showPlanCreation && (
        <PlanQuestionnaire
          onComplete={handleQuestionnaireComplete}
          onClose={handleBack}
        />
      )}

      {showPlanCreation && currentQuestionnaire && (
        <PlanCreation
          questionnaire={currentQuestionnaire}
          onSuccess={handlePlanCreationSuccess}
          onClose={handleClosePlanCreation}
        />
      )}
    </div>
  );
};

export default PlanQuestionnairePage;